import type { Richtext } from "storyblok-js-client";

const isEmpty = (richtext: Richtext) => {
  const { content } = richtext || {};

  if (!content) {
    return true;
  }

  if (content.length === 0) {
    return true;
  }

  if (content.length === 1 && !Object.prototype.hasOwnProperty.call(content[0], "content")) {
    return true;
  }

  return false;
};

export default isEmpty;
